import * as React from "react";
import styles from "./Footer.module.css";
import {
  Box,
  Container,
  Grid,
  styled,
  TextField,
  Typography,
} from "@mui/material";
import { Link } from "react-router-dom";
import X from "../../Assets/icons/icons8-x-50-1-1.png";
import Xhover from "../../Assets/icons/icons8-x-50-2.png";
import instagram from "../../Assets/icons/icons8-instagram-50-1-1.png";
import instagramhover from "../../Assets/icons/icons8-instagram-50-2.png";
import facebook from "../../Assets/icons/icons8-facebook-50-1-1.png";
import facebookhover from "../../Assets/icons/icons8-facebook-50-2.png";
import linkedin from "../../Assets/icons/icons8-linkedin-50-1-1.png";
import linkedinhover from "../../Assets/icons/icons8-linkedin-50-2.png";
import map from "../../Assets/icons/icons8-google-maps-old-50-1-1.png";
import maphover from "../../Assets/icons/icons8-google-maps-old-50-2.png";
import richmond from "../../Assets/richmond.jpg";
import stripe from "../../Assets/Stripe_logo.png";
import richmondLogo from "../../Assets/Richmond-Logo.png";
const CustomeTextField = styled(TextField)({
  "& label.Mui-focused": {
    color: "#949494",
  },
  "& .MuiInput-underline:after": {
    borderBottomColor: "#949494",
  },
  "& .MuiInput-root:before": {
    borderColor: "#949494",
    "&:hover": { color: "#949494", borderColor: "#949494" },
  },
  "& .MuiInput-root:before:hover": {
    borderColor: "#949494",
  },
  "& .MuiInputBase-root": {
    borderColor: "#949494",
    "& fieldset": {
      color: "#949494",
      borderColor: "#949494",
    },
  },
  "& .MuiInputBase-input": {
    color: "#949494",
    borderColor: "#949494",
  },
  "& .MuiInputLabel-root ": {
    color: "#949494",
    borderColor: "#949494",
  },
});

const Footer = () => {
  const [loading, setLoading] = React.useState(true);
  const [errorMessage, setErrorMessage] = React.useState("");
  const [name, setName] = React.useState("");
  const [email, setEmail] = React.useState("");
  const [successMessage, setSuccessMessage] = React.useState("");

  const nameChangeHandler = (event: any) => {
    setName(event.target.value);
  };

  const emailChangeHandler = (event: any) => {
    setEmail(event.target.value);
  };
  const validEmail =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  const formSubmitHandler = async (event: any) => {
    setSuccessMessage("");
    event.preventDefault();
    if (!(email && name))
      setErrorMessage("Please fill in your information completely");
    else if (!validEmail.test(String(email)))
      setErrorMessage("Invalid email address");
    else {
      setLoading(true);
      setErrorMessage("");
      try {
        // Create a new instance of the "Form" class
        const Form = Parse.Object.extend("Form");
        const form = new Form();

        // Set the form data
        form.set("type", "Subscription");
        form.set("userName", name);
        form.set("userEmail", email);

        form.set("status", "new");

        // Save the form data to Parse Server
        await form.save();
        setName("");
        setEmail("");

        setErrorMessage("");
        setSuccessMessage(
          "You're in! Get ready for artsy updates, framing ideas and invites to exclusive exhibits.",
        );
      } catch (error: any) {
        console.error("Error submitting form:", error);
        setErrorMessage(error.message);
      } finally {
        setLoading(false);
        // setModal("");
        Math.max();
      }
    }
  };
  return (
    <Box component="footer" sx={{ width: "100%", backgroundColor: "#330101" }}>
      <Container sx={{ py: 5 }}>
        <Typography variant="h4" component={"h1"} color={"#cccccc"}>
          Join our mailing list
        </Typography>
        <Grid container sx={{ justifyContent: "space-between" }}>
          <Grid
            component="form"
            container
            sx={{ justifyContent: "space-between" }}
            xs={12}
            md={7.5}
            item
          >
            <Grid item xs={4} md={4}>
              <CustomeTextField
                id="Name"
                label="Name"
                variant="standard"
                className={styles.input}
                sx={{ my: 3, width: "100%" }}
                onChange={nameChangeHandler}
              />
            </Grid>
            <Grid item xs={7.5} md={5}>
              <CustomeTextField
                id="email"
                label="Email"
                variant="standard"
                className={styles.input}
                sx={{ my: 3, width: "100%" }}
                onChange={emailChangeHandler}
              />
            </Grid>
            <Grid item xs={4} md={2} sx={{ mb: { xs: 2, md: 0 }, mt: 4 }}>
              <button className={styles.join} onClick={formSubmitHandler}>
                JOIN
              </button>
            </Grid>
            {errorMessage && (
              <Typography sx={{ color: "#949494" }}>{errorMessage}</Typography>
            )}
            {successMessage && (
              <Typography sx={{ color: "#949494" }}>
                {successMessage}
              </Typography>
            )}
            <br />
            <Typography sx={{ color: "#949494" }} variant="caption">
              By giving us your email address you agree to receive (thrilling)
              email updates, including special offers, new pieces and arty news.
              If you want you can unsubscribe at any time.
            </Typography>
          </Grid>
          <Grid item xs={12} md={3} sx={{ mb: { xs: 2, md: 0 } }}>
            <Typography sx={{ color: "#cccccc", textAlign: "center", mb: 1 }}>
              Join us across Social Media
            </Typography>
            <Box sx={{ display: "flex", gap: 1, justifyContent: "center" }}>
              <Link
                to={"https://maps.app.goo.gl/waUEBvsDAdQdzViM8"}
                target="blank"
                className={styles["social-container"]}
              >
                <img src={map} alt="google-map" className={styles.social} />
                <img
                  src={maphover}
                  alt="google-map"
                  className={styles.social}
                />
              </Link>
              <Link
                to={"https://www.linkedin.com/in/faam-gallery-50572626b/"}
                target="blank"
                className={styles["social-container"]}
              >
                <img src={linkedin} alt="linkedIn" className={styles.social} />
                <img
                  src={linkedinhover}
                  alt="linkedIn"
                  className={styles.social}
                />
              </Link>
              <Link
                to={"https://x.com/faamgallery"}
                target="blank"
                className={styles["social-container"]}
              >
                <img src={X} alt="X" className={styles.social} />
                <img src={Xhover} alt="X" className={styles.social} />
              </Link>
              <Link
                to={"https://www.facebook.com/faamgallery"}
                target="blank"
                className={styles["social-container"]}
              >
                <img src={facebook} alt="facebook" className={styles.social} />
                <img
                  src={facebookhover}
                  alt="facebook"
                  className={styles.social}
                />
              </Link>
              <Link
                to={"https://www.instagram.com/faamgallery"}
                target="blank"
                className={styles["social-container"]}
              >
                <img
                  src={instagram}
                  alt="instagram"
                  className={styles.social}
                />
                <img
                  src={instagramhover}
                  alt="instagram"
                  className={styles.social}
                />
              </Link>
            </Box>
          </Grid>
        </Grid>

        <Grid container sx={{ my: 4, justifyContent: "space-between" }}>
          <Grid
            item
            xs={12}
            sm={5.5}
            md={2}
            sx={{ textAlign: { xs: "center", md: "start" } }}
          >
            <Typography component="h2" variant="h5" sx={{ color: "#cccccc" }}>
              Services
            </Typography>
            <ul className={styles["footer-list"]}>
              <li>
                <Link to={"/instore-framing"}>
                  <Typography
                    variant="subtitle1"
                    sx={{ "&:hover": { color: "white" } }}
                  >
                    In-Store Framing
                  </Typography>
                </Link>
              </li>
              <li>
                <Link to={"/framing"}>
                  <Typography
                    variant="subtitle1"
                    sx={{ "&:hover": { color: "white" } }}
                  >
                    Online Framing
                  </Typography>
                </Link>
              </li>
              <li>
                <Link to={"/printing"}>
                  <Typography
                    variant="subtitle1"
                    sx={{ "&:hover": { color: "white" } }}
                  >
                    Printing
                  </Typography>
                </Link>
              </li>
              <li>
                <Link to={"/memorabilia"}>
                  <Typography
                    variant="subtitle1"
                    sx={{ "&:hover": { color: "white" } }}
                  >
                    Memorabilia
                  </Typography>
                </Link>
              </li>
              <li>
                <Typography
                  variant="subtitle1"
                  sx={{ "&:hover": { color: "white" } }}
                >
                  Restoration
                </Typography>
              </li>

              {/* <li>
                <Typography
                  variant="subtitle1"
                  sx={{ "&:hover": { color: "white" } }}
                >
                  For Artist
                </Typography>
              </li>
              <li>
                <Typography
                  variant="subtitle1"
                  sx={{ "&:hover": { color: "white" } }}
                >
                  For Business
                </Typography>
              </li> */}
            </ul>
          </Grid>
          <Grid
            item
            xs={12}
            sm={5.5}
            md={2}
            sx={{ textAlign: { xs: "center", md: "start" } }}
          >
            <Typography component="h2" variant="h5" sx={{ color: "#cccccc" }}>
              Activities
            </Typography>
            <ul className={styles["footer-list"]}>
              <li>
                <Link to={"/gallery"}>
                  <Typography
                    variant="subtitle1"
                    sx={{ "&:hover": { color: "white" } }}
                  >
                    Art Wall
                  </Typography>
                </Link>
              </li>
              <li>
                <Link to={"/gallery"}>
                  <Typography
                    variant="subtitle1"
                    sx={{ "&:hover": { color: "white" } }}
                  >
                    Exhibitions
                  </Typography>
                </Link>
              </li>
              <li>
                <Link to={"/blogs?blogType=press"}>
                  <Typography
                    variant="subtitle1"
                    sx={{ "&:hover": { color: "white" } }}
                  >
                    Press
                  </Typography>
                </Link>
              </li>
              <li>
                <Link to={"https://artsrichmond.org.uk/"} target="blank">
                  <img
                    src={richmond}
                    alt="arts-richmond"
                    style={{
                      width: "60%",
                      maxWidth: "10rem",
                      marginTop: "1rem",
                    }}
                  />
                </Link>
              </li>
            </ul>
          </Grid>
          <Grid
            item
            xs={12}
            sm={5.5}
            md={2}
            sx={{ textAlign: { xs: "center", md: "start" } }}
          >
            <Typography component="h2" variant="h5" sx={{ color: "#cccccc" }}>
              Shopping
            </Typography>
            <ul className={styles["footer-list"]}>
              <li>
                <Link to={"/shop"}>
                  <Typography
                    variant="subtitle1"
                    sx={{ "&:hover": { color: "white" } }}
                  >
                    Buy Artworks
                  </Typography>
                </Link>
              </li>
              <li>
                <Link to={"/blogs"}>
                  <Typography
                    variant="subtitle1"
                    sx={{ "&:hover": { color: "white" } }}
                  >
                    Blogs
                  </Typography>
                </Link>
              </li>
              <li>
                <Link to={"/artist"}>
                  <Typography
                    variant="subtitle1"
                    sx={{ "&:hover": { color: "white" } }}
                  >
                    Artists Index
                  </Typography>
                </Link>
              </li>
              <li>
                <Link to={"/terms&conditions"}>
                  <Typography
                    variant="subtitle1"
                    sx={{ "&:hover": { color: "white" } }}
                  >
                    Delivery & Returns Policy
                  </Typography>
                </Link>
              </li>
            </ul>
          </Grid>
          <Grid
            item
            xs={12}
            sm={5.5}
            md={2}
            sx={{ textAlign: { xs: "center", md: "start" } }}
          >
            <Typography component="h2" variant="h5" sx={{ color: "#cccccc" }}>
              Faam Gallery
            </Typography>
            <ul className={styles["footer-list"]}>
              <li>
                <Link to={"/about-us"}>
                  <Typography
                    variant="subtitle1"
                    sx={{ "&:hover": { color: "white" } }}
                  >
                    About us
                  </Typography>
                </Link>
              </li>
              <li>
                <Link to={"/contact-us"}>
                  <Typography
                    variant="subtitle1"
                    sx={{ "&:hover": { color: "white" } }}
                  >
                    Contact us
                  </Typography>
                </Link>
              </li>
              {/* <li>
                <Typography
                  variant="subtitle1"
                  sx={{ "&:hover": { color: "white" } }}
                >
                  FAQs
                </Typography>
              </li> */}
              <br />
              <li>
                <Link to={"mailto:info@faamgallery.com"} target="blank">
                  <Typography
                    variant="subtitle1"
                    sx={{ "&:hover": { color: "white" } }}
                  >
                    info@faamgallery.com
                  </Typography>
                </Link>
              </li>
              <li>
                <Link to={"mailto:framing@faamgallery.com"} target="blank">
                  <Typography
                    variant="subtitle1"
                    sx={{ "&:hover": { color: "white" } }}
                  >
                    framing@faamgallery.com
                  </Typography>
                </Link>
              </li>
              {/* <br /> */}
              <li>
                <Link to={"https://www.richmond.gov.uk/"} target="blank">
                  <img
                    src={richmondLogo}
                    alt="london borough of richmond upon thames"
                    style={{
                      width: "100%",
                      maxWidth: "10rem",
                      marginTop: "1rem",
                    }}
                  />
                </Link>
              </li>
            </ul>
          </Grid>
          <Grid
            item
            xs={12}
            sm={5.5}
            md={2}
            sx={{ textAlign: { xs: "center", md: "start" } }}
          >
            <Typography component="h2" variant="h5" sx={{ color: "#cccccc" }}>
              Visit us
            </Typography>

            <ul className={styles["footer-list"]}>
              <Link
                to={"https://maps.app.goo.gl/BLJgygUeavGavS146"}
                target="blank"
                style={{ fontWeight: "bolder", textDecoration: "underline" }}
              >
                <Typography
                  variant="subtitle1"
                  sx={{ fontWeight: "bolder", textDecoration: "underline" }}
                >
                  Whitton
                </Typography>
              </Link>
              <Typography
                variant="subtitle2"
                // sx={{ "&:hover": { color: "white" } }}
              >
                131 Percy Rd, TW2 6HT
                <br />
                <Link to={"tel:02036321468"} target="blank">
                  020 3632 1468
                </Link>
              </Typography>
            </ul>
            <ul className={styles["footer-list"]}>
              <Link
                to={"https://maps.app.goo.gl/Dmmv4HpyGHJhKj8n6"}
                target="blank"
                style={{ fontWeight: "bolder", textDecoration: "underline" }}
              >
                <Typography
                  variant="subtitle1"
                  sx={{ fontWeight: "bolder", textDecoration: "underline" }}
                >
                  Richmond
                </Typography>
              </Link>
              <Typography
                variant="subtitle2"
                // sx={{ "&:hover": { color: "white" } }}
              >
                16 Richmond Hill, TW10 6QX
                <br />
                <Link to={"tel:02036633293"} target="blank">
                  020 3663 3293
                </Link>
              </Typography>
            </ul>
          </Grid>
        </Grid>
        <Box sx={{ display: "flex", justifyContent: "center" }}>
          <Link to={"https://stripe.com/"} target="blank">
            <img
              src={stripe}
              alt="arts-richmond"
              style={{ width: "18rem", margin: "0 auto" }}
            />
          </Link>
        </Box>
        <Box
          sx={{ display: "flex", justifyContent: "center", flexWrap: "wrap" }}
        >
          <Typography
            variant="subtitle1"
            textAlign={"center"}
            sx={{ color: "#cccccc" }}
          >
            {new Date().getFullYear()} Faam Gallery | All rights reserved |
          </Typography>
          <Link to={"/privacy-policy"}>
            <Typography
              variant="subtitle1"
              textAlign={"center"}
              sx={{
                color: "#cccccc",
                marginLeft: 1,
                "&:hover": { color: "white" },
              }}
            >
              Privacy Policy |
            </Typography>
          </Link>

          <Link to={"/terms&conditions"}>
            <Typography
              variant="subtitle1"
              textAlign={"center"}
              sx={{
                color: "#cccccc",
                marginLeft: 1,
                "&:hover": { color: "white" },
              }}
            >
              Terms & Conditions
            </Typography>
          </Link>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
